const LanguageTypes = {
    NL: 'nl_NL',
    EN: 'en_GB',
    FR: 'fr_FR',
    DE: 'de_DE',
};

export default LanguageTypes;
